// ESM-Huelle um lib/scripts/pos/CLS_CPaymentProcessor.js (Phase 4, Welle 3) -
// Zahlung/Bon-Lebenszyklus, eines der sechs beim BonManager-Refactor extrahierten
// Module (Prototype-Mixin, wird im CBonManager-Konstruktor an die
// Instanz gebunden). Prototype-Stil bleibt vorerst.
// Strict-Mode-Fix (ESM): diese Namen wurden im Classic-Sloppy-Mode als
// implizite window-Globals angelegt (Zuweisung ohne var) - in Modulen
// wirft das ReferenceError. Modul-weite Deklaration stellt das alte
// Verhalten (dateiuebergreifend ungenutzte Temp-Variablen) her.
var card;


function CPaymentProcessor() {}

CPaymentProcessor.prototype.openBon = function () {

    var dfd = jQuery.Deferred();
    var BonManagerClass = this;
    // Der Funkscanner ist am 26.8.2026 entfallen (Geraet gibt es nicht mehr).
    // Vorher stand hier ein Waechter, der userId aus der Scanner-Sitzung nahm;
    // OHNE Scanner war barcodeRequested immer falsch, userId also immer null -
    // genau das bleibt hier stehen. Wichtig: die Zuweisung darf NICHT einfach
    // mitentfernt werden, sonst bekaeme Trans.openBon() undefined.
    var userId = null;
    $.when(Trans.openBon(userId)).then(function (currentBonId) {
        BonManagerClass.currentBonId = currentBonId;
        dfd.resolve(currentBonId);
    });
    return dfd.promise();
}

CPaymentProcessor.prototype.closeBon = function (voucher) {
    var BonManagerClass = this;
    var defret = $.Deferred();
    if (this.currentBonId == 0) {
        log.add(2, "Error", "Tried to close bon with BON_ID = 0!");
        this.reset();
        this.Main.components.info.input.setFocus();
        return;
    }

    // Bon-Abschluss-Ablauf, ehemals als tief verschachtelte $.when(...).done(
    // function(){ $.when(...).done(function(){ ... }) })-Pyramide geschrieben.
    // Hier als flache Kette benannter Schritte, weiterhin jQuery-Deferred-
    // basiert (kein async/await) - jede Funktion gibt einen Wert/Promise
    // zurueck, .then() wartet darauf und reicht das Ergebnis an den naechsten
    // Schritt weiter, exakt wie die vorherige Verschachtelung es tat.

    function stepRemakeInStock() {
        if (BonManagerClass.isPaydown) return 0;
        return Trans.remakeInStock(BonManagerClass.currentBonId, "CLS");
    }

    function stepCloseBonInDb() {
        return Trans.closeBon(BonManagerClass.currentBonId, "CLS", BonManagerClass.currentCustomerId);
    }

    function stepMakePOSId() {
        return $.when(Trans.makePOSId(BonManagerClass.currentBonId)).then(function (currentBonPOSId) {
            BonManagerClass.currentBonPOSId = currentBonPOSId;
        });
    }

    function stepLoadBonInfos() {
        return $.when(Trans.loadBonInfos(BonManagerClass.currentBonId)).then(function (InfoArray) {
            BonManagerClass.User = InfoArray["User"];
            BonManagerClass.DateTime = InfoArray["DateTime"];
            BonManagerClass.Customer = InfoArray["Customer"];
            if (BonManagerClass.wasPaydown)
                Trans.updateClosedField(BonManagerClass.wasPaydown, -1);
        });
    }

    function stepPosregAndPrint() {
        // rechnung nach RegKassenVerordnung  //muss vor printBon sein!!
        return $.when(BonManagerClass.AddEntryPOSREG()).then(function (withQRCode) {
            var receiptIdentifier = BonManagerClass.currentReceipt ?
                BonManagerClass.currentReceipt.receiptIdentifier : null;
            return $.when(printYearlyVoucherIfNeeded()).then(function () {
                return printBonAndFinish(withQRCode, receiptIdentifier);
            });
        });
    }

    function printYearlyVoucherIfNeeded() {
        if (!(BonManagerClass.currentReceipt && BonManagerClass.currentReceipt.printVC)) return 0;
        var BonMan = new CBonManager();
        BonMan.printMode = 'yearly_voucher';
        BonMan.currentReceipt = BonManagerClass.currentReceipt.PreviousReceipt;
        return BonMan.printBon(null, true, BonManagerClass.currentReceipt.receiptIdentifier - 1);
    }

    function printBonAndFinish(withQRCode, receiptIdentifier) {
        if (BonManagerClass.isPaydown)
            return printPaydownBon(withQRCode, receiptIdentifier);
        return printNormalBon(withQRCode, receiptIdentifier);
    }

    function printPaydownBon(withQRCode, receiptIdentifier) {
        Trans.updateClosedField(BonManagerClass.currentBonId, -3);
        var d = new Date();
        var timestamp = (d / 1000).toFixed(0);
        BonManagerClass.barcode = "555" + timestamp.toString() + BonManagerClass.currentBonId;
        BonManagerClass.printMode = "paydown";
        return $.when(BonManagerClass.printBon(voucher, withQRCode, receiptIdentifier)).then(function () {
            BonManagerClass.printMode = "paydown";
            BonManagerClass.showPaydownNote = true;
            return $.when(BonManagerClass.printBon(voucher, withQRCode, receiptIdentifier)).then(function () {
                Trans.updateClosedField(BonManagerClass.currentBonId, -3);
            });
        });
    }

    function printNormalBon(withQRCode, receiptIdentifier) {
        if (!BonManagerClass.printMode)
            BonManagerClass.printMode = "normal";
        return $.when(BonManagerClass.printBon(voucher, withQRCode, receiptIdentifier)).then(function (bontext) {
            sendToHelloAgainIfCustomer(bontext);
            if (BonManagerClass.isReclamationBon) {
                BonManagerClass.printMode = "billcopy";
                return BonManagerClass.printBon(voucher, withQRCode, receiptIdentifier);
            }
            checkLuckyNumber(receiptIdentifier);
        });
    }

    function sendToHelloAgainIfCustomer(bontext) {
        if (!BonManagerClass.currentCustomerId) return;
        log.add(4, "Info", "sendToHelloAgain", "");
        if (BonManagerClass.currentCustomerEAN === 0) { BonManagerClass.currentCustomerEAN = BonManagerClass.currentCustomerId };
        // Nur Hello-Again-Kunden (Nummernbereich, siehe CHelloAgainAPI.istKunde).
        if (!BonManagerClass.Bonus.istKunde(BonManagerClass.currentCustomerEAN)) {
            log.add(4, "Info", "sendToHelloAgain", "kein Hello-Again-Kunde - nicht gesendet");
            return;
        }
        // e-Beleg Stufe 2: auf den e-Beleg (Upload inkl. Link) warten und ihn
        // mitschicken. Bon-Daten VORHER festhalten - bis dahin kann der
        // BonManager schon fuer den naechsten Kunden zurueckgesetzt sein.
        var eintraege = BonManagerClass.currentBon;
        var receipt = BonManagerClass.currentReceipt;
        var ean = BonManagerClass.currentCustomerEAN;
        var bonus = BonManagerClass.Bonus;
        var bonId = BonManagerClass.currentBonId;
        $.when(BonManagerClass.eBelegFertig || null).always(function (eBeleg) {
            // Nur DIESEN Bon mitschicken: ohne Druck (Printer NO) gibt es keinen
            // neuen e-Beleg, eBelegFertig stammt dann noch vom vorigen Bon.
            if (!(eBeleg && eBeleg.beleg && eBeleg.beleg.bonId == bonId)) eBeleg = null;
            bonus.sendData(eintraege, receipt, bontext, ean, null, null, eBeleg);
        });
    }

    function checkLuckyNumber(receiptIdentifier) {
        //hier die Logik für das 33 Spiel Wochentage, Datum, Anzeige, am Display und am Schirm
        if (receiptIdentifier) {
            if (Number(receiptIdentifier % 100 == 33)) {
                const date = new Date();
                if (!(checkBusyDates(date))) {
                    if (typeof Display !== "undefined" && typeof Display.show33win === "function") {
                        Display.show33win(Display);
                        POS.message.show("       Kunde hat im Magic 33 Spiel gewonnen!", "info", "OK");
                    }
                }
            }
        }
    }

    function finish() {
        log.add(4, "Info", "Bon number " + BonManagerClass.currentBonId + " was closed succesfully", "");
        BonManagerClass.reset();
        BonManagerClass.Main.components.info.input.setFocus();
        defret.resolve();
        POS.runPOSPush();
    }

    $.when(stepRemakeInStock())
        .then(stepCloseBonInDb)
        .then(stepMakePOSId)
        .then(stepLoadBonInfos)
        .then(stepPosregAndPrint)
        .then(finish);

    return defret.promise();
}

CPaymentProcessor.prototype.cancelBon = function (reasonId, reasonText, bonId, mode) {

    var defret = $.Deferred();
    var BonManagerClass = this;
    if (!mode)
        mode = "cancelprotocol";
    var def2 = $.Deferred();
    if (bonId) {
        $.when(this.loadFromId(bonId)).done(function () {
            $.when(Trans.cancelBon(bonId, reasonId)).done(function () {
                def2.resolve();
            });
        })
    } else {
        $.when(Trans.cancelBon(this.currentBonId, reasonId)).done(function () {
            def2.resolve();
        });
    }
    $.when(def2).done(function () {
        $.when(Trans.getReferenceBill(bonId ? bonId : BonManagerClass.currentBonId)).then(function (refBillId) {
            var def = $.Deferred();
            if (refBillId) {
                $.when(Trans.getBonIdFromPosBon(refBillId)).then(function (oldBonId) {
                    Trans.uncancelBon(oldBonId);
                    def.resolve();
                });
            } else {
                def.resolve();
            }
            $.when(def).done(function () {
                BonManagerClass.DateTime = new Date();

                BonManagerClass.cancelReasonText = umlauToEntity(reasonText);
                var r7 = $.Deferred();
                if (mode != "cancellation") {
                    BonManagerClass.printMode = mode;
                    $.when(BonManagerClass.printBon()).done(function () {
                        r7.resolve();
                    });
                } else {
                    r7.resolve();
                }
                var r6 = $.Deferred();
                $.when(r7).done(function () {
                    if (mode == "cancellation" && !BonManagerClass.isPaydown) {
                        $.when(Trans.remakeInStock(bonId, "CAN")).then(function () {
                            var cnts = Object.keys(BonManagerClass.currentBon);
                            var iterator = function it(i) {
                                if (i < cnts.length) {
                                    var cnt = cnts[i];
                                    var entry = BonManagerClass.currentBon[cnt];
                                    if (entry.type == 'PAY' && !entry.cancelled && entry.text1 == 'PPC') {
                                        var PPC = new CPrepaidCardPayment();
                                        $.when(Trans.getPosBonId(BonManagerClass.currentBonId)).then(function (bonID) {
                                            PPC.addCancelledPayment(BonManagerClass.currentBonId, bonID, entry.amount);
                                            iterator(i + 1);
                                            return;
                                        });
                                    }
                                    else if (entry.type == 'POS' && !entry.cancelled) {
                                        $.when(Trans.getPPCProduct()).then(function (val) {
                                            if (val == entry.productId) {
                                                PPC = new CPrepaidCardPayment();
                                                $.when(Trans.getPosBonId(BonManagerClass.currentBonId)).then(function (bonID) {
                                                    PPC.addCancelledCharge(BonManagerClass.currentBonId, bonID, entry.amount);
                                                    iterator(i + 1);
                                                    return;
                                                });
                                            } else {
                                                iterator(i + 1);
                                                return;
                                            }

                                        });
                                    } else {
                                        iterator(i + 1);
                                        return;
                                    }

                                } else {
                                    r6.resolve();
                                    return;
                                }
                            }
                            iterator(0);
                        });

                    } else {
                        r6.resolve();
                    }
                    $.when(r6).done(function () {

                        BonManagerClass.reset();

                        Display.addLine();
                        Display.addElement("* STORNO *", 9, 2, 0, 19);
                        Display.addLine();
                        Display.addElement("", 9, 2, 0, 19);
                        Display.out();

                        window.setTimeout(BonManagerClass.initDisplay, 5000);
                        defret.resolve();
                    });
                });
            });
        });
    });
    return defret.promise();
}

CPaymentProcessor.prototype.isCashPayment = function () { //Kreditkarte und Bankomat und Gutschein z�hlen als Barzahlung
    if (this.shortcut && (this.shortcut == "BAR" || this.shortcut == "VCR" || this.shortcut == "BCC" || this.shortcut == "PPC")) {
        //Wertkarte z�hlt nicht!!
        if (this.isPPCCharge()) {
            return false;
        }
        return true;
    } else {
        return false;
    }
}

CPaymentProcessor.prototype.isPPCCharge = function (Entry, is33) { //Kreditkarte und Bankomat und Gutschein z�hlen als Barzahlung

    if (is33) {
        return false;
    }
    if (!Entry) {
        Entry = this.getSelectedItem();
    }
    if (Entry && Entry.product && Entry.product.ean == "VTPPC") {
        return true;
    }
    return false;
}

CPaymentProcessor.prototype.addEntryPAY = function (paymentId, amount) {
    var BonManagerClass = this;
    if (this.currentBonId == 0)
        return;

    var isPaydown = this.Main.isPaydown;
    this.Main.isPaydown = false;

    if (isPaydown && !amount) {
        POS.hourGlass.hide();
        var text = POS.lang.getText("MESSAGES", "NO_AMOUNT");
        POS.message.show(text, "warning", "");
        return;
    }

    var found = false;
    for (var Cnt in this.currentBon) {
        var Entry = this.currentBon[Cnt];
        if (!Entry.cancelled) {
            found = true;
            break;
        }
    }
    if (!found) {
        POS.hourGlass.hide();
        text = POS.lang.getText("MESSAGES", "NO_PAY_POSITIONS");
        POS.message.show(text, "warning", "OK");
        return;
    }
    // Sperre gegen Doppeltipp (Filiale Breitenfurt 12.10.2026, Bon 2824750):
    // ein zweiter Tipp auf eine Zahlart, waehrend die erste Zahlung noch
    // angelegt wird, rechnete mit 0 EUR offen und legte eine zweite
    // Zahlzeile an. Die Sperre endet, sobald der Zahlungsschirm steht (oder
    // die Zahlung abgewiesen ist) - und spaetestens nach 10 s, damit ein
    // unerwarteter Fehler im Ablauf die Kasse nie dauerhaft sperrt.
    if (BonManagerClass.zahlungWirdAngelegt && Date.now() - BonManagerClass.zahlungWirdAngelegt < 10000) {
        log.add(2, "Warning", "Zahlung", "zweiter Tipp waehrend die Zahlung angelegt wird - ignoriert");
        return;
    }
    BonManagerClass.zahlungWirdAngelegt = Date.now();
    var zahlungAngelegt = function () { BonManagerClass.zahlungWirdAngelegt = 0; };
    $.when(Trans.getPaymentInfo(paymentId)).then(function (Payment) {
        if (Payment["shortcut"] == "BCC" && POS.bankomatActive) {
            zahlungAngelegt();
            POS.hourGlass.hide();
            var text = POS.lang.getText("MESSAGES", "BANKOMAT_ALREADY_BUSY");
            POS.message.show(text, "warning", "");
            return;
        }

        if (!Payment) {
            zahlungAngelegt();
            POS.hourGlass.hide();
            text = POS.lang.getText("MESSAGES", "NO_PAY_REFERENCE");
            POS.message.show(text, "critical", "OK");
            return;
        }

        // Nacharbeit B4: die Kasse ist beim Finanzamt abgemeldet (Schlussbeleg
        // signiert) - Barumsaetze (Zahlarten, die einen RKSV-Beleg erzeugen,
        // vgl. isCashPayment) werden mit klarer Meldung verweigert, nie als
        // Ausfall-Beleg erfasst.
        if (POS.Smartcard && POS.Smartcard.ausserBetrieb && ["BAR", "VCR", "BCC", "PPC"].indexOf(Payment.shortcut) >= 0) {
            zahlungAngelegt();
            POS.hourGlass.hide();
            POS.Smartcard.ausserBetriebMelden();
            return;
        }

        if (Payment.shortcut == "PPU") {
            var d = new Date();
	    let hasRebate=false;
				if (!BonManagerClass.isRightPPUTime(d.getHours(), d.getMinutes())) {
					zahlungAngelegt();
					POS.hourGlass.hide();
					var text = POS.lang.getText("MESSAGES", "NO_PERSONAL_PURCHASE_TIME");
					POS.message.show(text, "warning", "OK");
					return;
				}
				
			for (var i = 0; i < BonManagerClass.currentBon.length; i++) {
				if (BonManagerClass.currentBon[i].type.includes("RB", 1)) {
					hasRebate = true;
				}
			}
		
			if (BonManagerClass.isPPCCharge() || hasRebate) {
				zahlungAngelegt();

				var text = "Kein Rabatt f&uuml;r dieses Produkt m&ouml;glich bzw. bei Personalkauf keine rabattierten Produkte m&ouml;glich!"
					POS.message.show(text, "warning", "OK");
				return ;
			}
        }

        var openSum = BonManagerClass.getSumArray()[6];
        var def = $.Deferred();
        if (openSum < 0) {

            $.when(Trans.getReferenceBill(BonManagerClass.currentBonId)).then(function (refBill) {
                if (!refBill || (refBill && Payment.shortcut != "BAR")) {
                    POS.hourGlass.hide();
                    var text = POS.lang.getText("MESSAGES", "NEGATIVE_BONSUM");
                    POS.message.show(text, "warning", "OK");
                    def.reject();
                    return;
                } else {
                    def.resolve();
                }
            });
        } else {
            def.resolve();
        }
        $.when(def).fail(zahlungAngelegt);
        $.when(def).then(function () {
            if (isPaydown)
                openSum = amount;
            else if (Payment.shortcut != "BCC" && Payment.shortcut != "PPC")
                amount = 0;

            // Bankomat ohne offenen Betrag: der Kartenschirm rief dann eine
            // Storno-Buchung ohne Zahlungsbeleg auf und stuerzte ab
            // ("reading 'voucherNo'"), der Schirm blieb haengen (Breitenfurt
            // 12.10.2026). Stattdessen klare Meldung, keine Zahlzeile.
            if (Payment["shortcut"] == "BCC" && !(openSum > 0)) {
                zahlungAngelegt();
                POS.hourGlass.hide();
                POS.message.show(POS.lang.getText("MESSAGES", "PPC_NOTHING_TO_PAY"), "warning", "OK");
                return;
            }

            if (amount == "")
                var payAmount = 0;
            else
                payAmount = parseFloat(amount);

            var returnAmount = (payAmount > openSum) ? fix2Decimals(payAmount - openSum) : 0;

            BonManagerClass.currentIndex++;
            // Platz der neuen Zeile JETZT merken - bis defreturn kann
            // currentIndex schon weitergezaehlt sein.
            var index = BonManagerClass.currentIndex;
            if (Payment["shortcut"] == "BCC")
                payAmount = payAmount ? payAmount : openSum;

            var r4 = new CBonEntry(index, "PAY", "NIL", null,
                    Payment["shortcut"], null, null, payAmount, null, 0);
            $.when(r4.defreturn).done(function (c) {
                var Entry = c;
                BonManagerClass.currentBon[index] = Entry;

                $.when(Trans.addEntry(BonManagerClass.currentBonId, Entry)).done(function (id) {
                    $.when(Trans.cancelEntry(Entry)).done(function () {
                        BonManagerClass.shortcut = Payment["shortcut"];
                        BonManagerClass.showSum();

                        // Write back Data for Callback
                        BonManagerClass.pendingPayment = new Array();
                        BonManagerClass.pendingPayment["entry"] = Entry;
                        BonManagerClass.pendingPayment["haveReturn"] = returnAmount > 0;

                        BonManagerClass.pendingPayment["closeBon"] = BonManagerClass.getSumArray()[6] == 0;

                        // Deactivate Entry
                        Entry.cancelled = true;

                        if (Payment["returnMoneyScreen"]) {
                            if (openSum < 0)
                                BonManagerClass.Main.cmpBAR.isNegative = true;
                            BonManagerClass.Main.cmpBAR.paymentType = Payment["shortcut"];
                            BonManagerClass.Main.cmpBAR.openSum = openSum;
                            BonManagerClass.Main.cmpBAR.payAmount = 0;
                            BonManagerClass.Main.cmpBAR.returnAmount = 0;
                            BonManagerClass.Main.cmpBAR.openMoney = openSum;
                            BonManagerClass.Main.cmpBAR.show();
                        } else if (Payment["shortcut"] == "PPU") {
                            BonManagerClass.cmpPPU = BonManagerClass.Main.addChild(CPersonalPurchaseMode);
                            BonManagerClass.cmpPPU.openSum = openSum;
                            BonManagerClass.cmpPPU.wholeSum = BonManagerClass.getSumArray()[0];
                            BonManagerClass.cmpPPU.draw();
                            document.getElementById(BonManagerClass.cmpPPU.id).style.visibility = "visible";
                        } else if (Payment["shortcut"] == "BCC") {
                            BonManagerClass.cmpBCC = BonManagerClass.Main.addChild(CCardPaymentMode);
                            BonManagerClass.cmpBCC.Main = BonManagerClass.Main;
                            BonManagerClass.cmpBCC.amount = payAmount;
                            BonManagerClass.cmpBCC.openAmount = (payAmount == openSum) ? 0 : openSum;
                            BonManagerClass.cmpBCC.cardType = Payment["cardtype"];
                            BonManagerClass.cmpBCC.draw();
                            document.getElementById(BonManagerClass.cmpBCC.id).style.visibility = "visible";
                            if (openSum > 0) {
                                if (POS.EnvProperties.BANKOMATTERMINAL == "YES") {
                                    if (Payment["cardtype"] == "CC")
                                        BonManagerClass.cmpBCC.makeCreditTransaction(BonManagerClass.currentBonId);
                                    else if (Payment["cardtype"] == "BC")
                                        BonManagerClass.cmpBCC.makeDebitTransaction(BonManagerClass.currentBonId);
                                } else {
                                    BonManagerClass.cmpBCC.makeOkButtons();
                                    BonManagerClass.cmpBCC.paymentType = Payment["cardtype"];
                                }
                            } else
                                BonManagerClass.cmpBCC.makeNegTransaction(BonManagerClass.currentBonId);
                        } else if (Payment["shortcut"] == "CNT") {
                            BonManagerClass.openZNTSum = openSum;
                            text = POS.lang.getText("MESSAGES", "CONF_CENTRAL_PAYMENT");
                            POS.message.show(text, "warning", "YESNO", BonManagerClass, BonManagerClass.makeCentralPayment);
                        } else if (Payment["shortcut"] == "DLP") {
                            BonManagerClass.openDLPSum = openSum;
                            text = POS.lang.getText("MESSAGES", "CONF_DELIVERY_PAYMENT");
                            POS.message.show(text, "warning", "YESNO", BonManagerClass, BonManagerClass.makeDeliveryPayment);
                        } else if (Payment["shortcut"] == "PPC")
                            BonManagerClass.payCallback(BonManagerClass, null, amount, 0, openSum - amount);

                        if (isPaydown)
                            POS.hourGlass.hide();
                        BonManagerClass.isPaydown = isPaydown;
                        zahlungAngelegt();
                    });
                });
            });
        });
    });
}

CPaymentProcessor.prototype.makeCentralPayment = function (me, result) {
    if (result != "YES")
        return;

    me.payCallback(me, null, me.openZNTSum, 0, 0);
}

CPaymentProcessor.prototype.makeDeliveryPayment = function (me, result) {
    if (result != "YES")
        return;

    me.payCallback(me, null, me.openDLPSum, 0, 0);
}

CPaymentProcessor.prototype.payCallback = function (cls, voucher, payAmount, returnAmount, openAmount) {
    // Schutz gegen doppelte Zahlungsverarbeitung fuer denselben Bon: die Buttons
    // in CMP_CTransactionShowMode.js werden ueber doCancel() reaktiviert, sobald
    // die Kassenlade als geschlossen erkannt wird - unabhaengig davon, ob diese
    // asynchrone Kette (RKSV-Signatur -> closeBon -> AddEntryPOSREG -> Druck) schon
    // fertig ist. Haengt die Signatur (z.B. wegen gezogener Smartcard, bis zu 25s
    // Timeout), kann ein ungeduldiger zweiter Klick auf "Bar" denselben, noch
    // offenen Bon ein zweites Mal komplett bezahlen/abschliessen (doppelte
    // PAY/RET-Zeilen, doppelte BONREG-Eintraege). Siehe [[pos-bon-doppelzahlung-fix]].
    if (cls.isProcessingPayment) {
        log.add(2, "Error", "payCallback fuer Bon " + cls.currentBonId +
            " ignoriert - vorherige Zahlung wird noch verarbeitet (Doppelklick-Schutz)");
        var alreadyRunning = $.Deferred();
        alreadyRunning.resolve();
        return alreadyRunning.promise();
    }
    cls.isProcessingPayment = true;

    var Entry = cls.pendingPayment["entry"];
    Entry.amount = payAmount;
    var defret = $.Deferred();
    returnAmount = fix2Decimals(returnAmount);

    var billId = null;
    if (voucher) {
        if (typeof voucher.voucherNo != "undefined")
            billId = parseFloat(voucher.voucherNo);
    }

    if (voucher)
        Entry.text2 = voucher.DBId;

    $.when(Trans.uncancelEntry(Entry, (voucher ? voucher.DBId : null), payAmount, billId)).done(function () {
        Entry.cancelled = false;
        var def = $.Deferred();
        if (returnAmount > 0) {
            cls.currentIndex++;
            var Entry2 = new CBonEntry(cls.currentIndex, "RET", "NIL", Entry,
                    cls.shortcut, null, Entry, returnAmount,
                    null, 0);
            $.when(Entry2.defreturn).done(function (c) {
                cls.currentBon[cls.currentIndex] = Entry2;
                Entry.referencedBy[cls.currentIndex] = Entry2;
                $.when(Trans.addEntry(cls.currentBonId, Entry2)).done(function (id) {
                    def.resolve();
                });
            });
        } else {
            def.resolve();
        }
        $.when(def).done(function () {
            if (payAmount > 0) {
                var def2 = cls.redrawBonSum();
            } else {
                def2 = 0;
            }
            $.when(def2).done(function () {
                if (openAmount == 0 || cls.isPaydown) {
                    if (typeof voucher != "undefined" && POS.EnvProperties.BANKOMATTERMINAL == "NO")
                        voucher = null;

                    var isPPCPayment = false;

                    for (var cnt in cls.currentBon) {
                        var entry = cls.currentBon[cnt];
                        if (entry.type == "PAY" && !entry.cancelled && entry.text1 == "PPC") {
                            isPPCPayment = true;
                            break;
                        }
                    }

                    if (!isPPCPayment) {
                        var def3 = cls.closePayment(cls, voucher, false);
                    } else {
                        cls.rememberVoucher = voucher;
                        var PPC = new CPrepaidCardPayment();
                        def3 = PPC.checkBonPayment(cls.Main.UID, POS.POSId, cls.currentBonId);
                        POS.hourGlass.show(POS.lang.getText("MESSAGES", "PLEASE_WAIT"), null, null);
                    }
                } else {
                    def3 = 0;
                }
                $.when(def3).done(function () {
                    if (cls.displayMode == "purchase")
                        Trans.updatePurchaser(cls.displayTarget.purchaserId);

                    cls.isProcessingPayment = false;
                    defret.resolve();
                });
            });
        });
    });
    return defret.promise();
}

CPaymentProcessor.prototype.closePayment = function (cls, voucher, isPPCPayment) {
    var curBonId = cls.currentBonId;

    var bonPositions = cls.currentBon;
    var defret = $.Deferred();
    // this block is only when PPC chargings are found!
    var newPPCCredits = new Array();

    $.when(Trans.getPPCProduct()).then(function (val) {

        /*
        for (var cnt in bonPositions){
        var entry = bonPositions[cnt];
        if (entry.type == 'POS' && !entry.cancelled && val == entry.productId){
        var creditData = Trans.getText2(entry.dbid).toString().replace(',', '.').split(';');
        var credit = parseFloat(creditData[0]);
        var cardId = creditData[1];
        var charge = parseFloat(entry.amount.toString().replace(',', '.'));
        var found = false;
        for (var card in newPPCCredits){
        if (card == cardId)
        found = true;
        }
        if (found)
        newPPCCredits[cardId] += charge
        else
        newPPCCredits[cardId] = credit + charge
        }
        }*/

        var def = $.Deferred();
        var cnts = Object.keys(bonPositions);
        var iterator = function it(i) {
            if (i < cnts.length) {
                var cnt = cnts[i];
                var entry = bonPositions[cnt];
                $.when(Trans.getText2(entry.dbid)).then(function (cD) {
                    if (cD) {
                        var creditData = cD.toString().replace(',', '.').split(';');
                        var entry = bonPositions[cnt];
                        if (entry.type == 'POS' && !entry.cancelled && val == entry.productId) {
                            var credit = parseFloat(creditData[0]);
                            var cardId = creditData[1];
                            var charge = parseFloat(entry.amount.toString().replace(',', '.'));
                            var found = false;
                            for (var card in newPPCCredits) {
                                if (card == cardId)
                                    found = true;
                            }
                            if (found) {
                                newPPCCredits[cardId] += charge
                            } else {
                                newPPCCredits[cardId] = credit + charge
                            }
                        }
                    }
                    iterator(i + 1);
                    return;
                });
            } else {
                def.resolve();
                return;
            }
        };
        iterator(0);

        $.when(def).done(function () {
            for (card in newPPCCredits) {
                if (cls.prepaidCardCredits)
                    cls.prepaidCardCredits += '*' + card + ";" + newPPCCredits[card];
                else
                    cls.prepaidCardCredits = card + ";" + newPPCCredits[card];
            }

            // always:
            $.when(cls.closeBon(voucher)).then(function (bonID) {
                $.when(Trans.getPosBonId(curBonId)).then(function (bonID) {

                    // again, from here on only when PPC chargings or payments are found!
                    var cnts2 = Object.keys(bonPositions);
                    var def2 = $.Deferred();
                    var iterator2 = function it2(i) {
                        if (i < cnts2.length) {
                            var cnt = cnts2[i];
                            var entry = bonPositions[cnt];
                            if (entry.type == 'POS' && !entry.cancelled && val == entry.productId) {
                                var PPC = new CPrepaidCardPayment();
                                $.when(PPC.validatePayment(curBonId, bonID, entry.interaction, entry.amount)).done(function () {
                                    iterator2(i + 1);
                                });
                            } else {
                                iterator2(i + 1);
                            }
                        } else {
                            def2.resolve();
                        }
                    }
                    iterator2(0);

                    $.when(def2).done(function () {
                        if (isPPCPayment) {
                            var PPC = new CPrepaidCardPayment();
                            PPC.sendBillNumber(curBonId, bonID);
                        }
                        defret.resolve();
                    });
                });
            });
        });
    });
    return defret.promise();
}

CPaymentProcessor.prototype.testPPCPaymentPing = function (me) {
    if (POS.sessions.getSessionComponent() == me.Main) {
        POS.hourGlass.hide();
        var text = POS.lang.getText("MESSAGES", "PING_TOO_LONG");
        POS.message.show(text, "warning", "OK");
    }
}

CPaymentProcessor.prototype.checkPPCPaymentAnswer = function (ok, prepaidCardCredits) {
    POS.hourGlass.hide();
    var BonManagerClass = this;
    var defret = $.Deferred();
    switch (ok) {
    case "NOK": //zur Zeit gibt es kein NOK
        var text = POS.lang.getText("MESSAGES", "PPC_PAYMENT_NOT_POSSIBLE");
        POS.message.show(text, "warning", "OK");
        $.when(Trans.cancelPPCPayments(this.currentBonId)).done(function () {
            for (var cnt in BonManagerClass.currentBon) {
                var entry = BonManagerClass.currentBon[cnt];
                var d = new Date();
                var timestamp = (d / 1000).toFixed(0);
                if (entry.type == "PAY" && !entry.cancelled && entry.text1 == "PPC") {
                    entry.cancelled = timestamp;
                    entry.interaction = 'CAN'
                }
            }
            $.when(BonManagerClass.redrawBonSum()).done(function () {
                $.when(BonManagerClass.runRedrawBonArray()).done(function () {
                    var PPC = new CPrepaidCardPayment();
                    $.when(PPC.deletePaymentsInBon(BonManagerClass.currentBonId)).done(function () {
                        defret.resolve();
                    });
                });
            });
        });
        break;
    case "OK":
        BonManagerClass.prepaidCardCredits = prepaidCardCredits;
        $.when(BonManagerClass.closePayment(BonManagerClass, BonManagerClass.rememberVoucher, true)).done(function () {
            defret.resolve();
        });
        break;
    default:
        defret.resolve();
    }

    return defret.promise();
}

CPaymentProcessor.prototype.isRightPPUTime = function (hour, minute) {
    if (typeof this.Main.userProps["PPU"] != "undefined" && this.Main.userProps["PPU"] == -1)
        return true;

    hour = parseFloat(hour);
    minute = parseFloat(minute);

    var xml = new CXmlHandler("var/etc/ini.xml");

    var earliestTimeLimit = xml.getValue("initData.personalPurchase.week.begin");
    var latestTimeLimit = xml.getValue("initData.personalPurchase.week.end");

    var minLimitParts = earliestTimeLimit.split(":");
    var maxLimitParts = latestTimeLimit.split(":");

    minLimitParts[0] = parseFloat(minLimitParts[0]);
    minLimitParts[1] = parseFloat(minLimitParts[1]);
    maxLimitParts[0] = parseFloat(maxLimitParts[0]);
    maxLimitParts[1] = parseFloat(maxLimitParts[1]);

    if (minLimitParts[0] < hour && maxLimitParts[0] > hour)
        return true;

    if (minLimitParts[0] == hour && minLimitParts[1] <= minute)
        return true;

    if (maxLimitParts[0] == hour && maxLimitParts[1] > minute)
        return true;

    return false;
}

CPaymentProcessor.prototype.makeDeliveryReceipt = function () {
    var BonManagerClass = this;
    $.when(Trans.remakeInStock(this.currentBonId, "DRC")).then(function (barcode) {
        Trans.closeBon(BonManagerClass.currentBonId, "DRC");
        BonManagerClass.reset();
    });
}

export { CPaymentProcessor };
